// src/components/SignOut.tsx
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { auth } from '../firebase.js';

const SignOut = () => {
  const location = useLocation();

  useEffect(() => {
    auth.signOut();
  }, []);

  return <Navigate to="/" state={{ from: location }} replace />;
};

export default SignOut;
